import { CheckIcon } from "./icons.tsx"
import { Link, Routes } from "./link.tsx"

export const MerchCard = (props: MerchCard.Props) => {
  if (props.owned) {
    return (
      <MerchCardLink merchId={props.merchId}>
        <img
          src={props.imageSrc}
          alt={props.title}
          className="size-full object-cover aspect-square"
        />
        <div className="absolute top-2 right-2">
          <CheckIcon className="size-5" />
        </div>
      </MerchCardLink>
    )
  }

  return (
    <MerchCardLink merchId={props.merchId}>
      <img
        src={props.imageSrc}
        alt={props.title}
        className="size-full object-cover aspect-square"
      />
    </MerchCardLink>
  )
}

const MerchCardLink = ({ children, merchId }: MerchCard.LinkProps) => {
  return (
    <Link to={Routes.merchDetail(merchId)} className="relative bg-grayA-3">
      {children}
    </Link>
  )
}

namespace MerchCard {
  export type Props = {
    merchId: string
    title: string
    imageSrc: string
    owned: boolean
  }
  export type LinkProps = {
    children: React.ReactNode
    merchId: string
  }
}
